import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { IEventApiResponse } from '../../types/api/eventApi';
import { getEventDataService } from '../../api/eventApi';
import { IEventState } from '../../types/features/eventSlice';

export const getEventData = createAsyncThunk<IEventApiResponse>(
    'event/getEventData',
    async () => {
        const response = await getEventDataService();
        return response.data; // Assumes response has a 'data' property
    }
);

const eventSlice = createSlice({
    name: 'event',
    initialState: {
        plan_event: {
            name: '',
            description: '',
            image: '',
            link: '',
        },
        meeting_venue: [],
        eventLoader: false,
        status: false,
        msg: ''
    } as IEventState, // Type the initialState with AuthState
    reducers: {
    },
    extraReducers: (builder) => {
        builder
            .addCase(getEventData.pending, (state) => {
                state.eventLoader = true;
            })
            .addCase(getEventData.fulfilled, (state, action: PayloadAction<IEventApiResponse>) => {
                state.plan_event = action.payload.data.plan_event;
                state.meeting_venue = action.payload.data.meeting_venue;
                state.msg = action.payload.message;
                state.status = true;
                state.eventLoader = false;
            })
            .addCase(getEventData.rejected, (state, action) => {
                state.eventLoader = false;
                state.status = false;
                state.msg = action.error.message;
            })

    }
});

export default eventSlice.reducer;
